import {useState} from 'react';

import styles from './styles/dropdown-filter.module.css';

import {ReactComponent as ArrowDownIcon} from '../../../assets/common/arrow-down.svg';
import {ReactComponent as ArrowUpIcon} from '../../../assets/common/arrow-up.svg';

export default function DropdownFilter({ type, itemMap, name, handleChange }) {
    const initializeSelectedItem = (type) => {
        if (type === 'feedback-state') return '학습 상태';
        if (type === 'feedback-content') return '피드백 내용';
        return type;
    };

    const [openDropdown, setOpenDropdown] = useState(false);
    const [selectedItem, setSelectedItem] = useState(initializeSelectedItem(type));
    const [btnColor, setBtnColor] = useState('gray-blue-dark');

    const toggleDropdown = () => {
        setOpenDropdown(!openDropdown);
    };

    const clickItem = (item) => {
        if (item.name === '오류') return;

        handleChange({ target: { name: name, value: item.value } });

        setSelectedItem(item.name);
        setOpenDropdown(false);

        const isInItemMap = itemMap.some(mapItem => mapItem.name === item.name);

        if (isInItemMap) {
            setBtnColor('black');
        }
    };

    return (
        <div className={styles.wrapper}>
            <button datatype={type}
                    data-type-2={btnColor}
                    onClick={toggleDropdown}
            >
                <p>{selectedItem}</p>
                {openDropdown ? <ArrowUpIcon /> : <ArrowDownIcon />}
            </button>
            {openDropdown &&
                <ul datatype={type}>
                    {itemMap.map(item => (
                        <li key={item}
                            datatype={type}
                            data-type-2={item.name}
                            onClick={() => clickItem(item)}
                        >
                            {item.name}
                        </li>
                    ))}
                </ul>
            }
        </div>
    );
}
